module.exports = __webpack_public_path__ + "static/media/book7.4bad6049.jpg";